import { makeStyles } from "@mui/styles";
import { colors, Commons } from "styleguide";

const useStyles = makeStyles({
  container: {
    marginTop: 60,
  },
  rowTitle: {
    ...Commons.flexCenter,
    margin: "0 0 24px 0",
  },
  title: {
    color: colors.white,
    fontSize: 30,
    flex: 1,
    margin: 0,
    [Commons.smallQuery]: {
      fontSize: 18,
    },
  },
  rowNavigation: {
    ...Commons.flexRow,
    gap: 18,
  },
  buttonNavigation: {
    ...Commons.defaultButton,
    ...Commons.flexCenter,
    backgroundColor: colors.white,
    boxShadow: colors.shadowWhite,
    width: 36,
    height: 36,
    borderRadius: "50%",
  },
  rowItems: {
    whiteSpace: "nowrap",
    overflowY: "auto",
    marginBottom: 60,
    height: 450,
    [Commons.smallQuery]: {
      height: 402,
    },
  },
});

export default useStyles;
